import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "pdm_pending_banner_dismissed";

export default function PendingOrdersBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");

  useEffect(() => { setHidden(sessionStorage.getItem(KEY) === "1"); }, [user?.id]);

  useEffect(() => {
    if (!user || user.role !== "customer" || hidden) return;
    api.get("/customer/orders").then(({ data }) => setCount(data.filter((o) => ["pending", "awaiting_cheque"].includes(o.payment_status)).length)).catch(() => {});
  }, [user, hidden, pathname]);

  if (!user || user.role !== "customer" || hidden || !count || pathname.startsWith("/admin")) return null;
  const close = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div data-testid="pending-orders-banner" className="border-b border-amber-deep/20 bg-amber-100/80">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2.5 text-sm text-bark sm:px-8">
        <Clock size={16} className="shrink-0 text-amber-deep" />
        <p className="flex-1">
          Vous avez <strong>{count} commande{count > 1 ? "s" : ""} en attente de paiement</strong>.{" "}
          {pathname !== "/compte" && <Link to="/compte" onClick={close} data-testid="pending-orders-banner-link" className="font-semibold text-amber-deep underline underline-offset-2">Gérer mes commandes</Link>}
        </p>
        <button data-testid="pending-orders-banner-close" onClick={close} aria-label="Fermer" className="rounded-full p-1 text-bark-soft hover:bg-white/60"><X size={15} /></button>
      </div>
    </div>
  );
}
